<template>
  <div v-if="isAdmin" class="container">
    <h1 class="text-danger"><i class="fa fa-wrench"></i> Set Category Winners</h1>
    <hr>
    <div class="card bg-body-tertiary">
      <div class="card-header">
        <strong>OscarPool Event Stream Settings</strong>

        <span class="stream-text">stream</span>
        <div :class="`connection-indicator ${streamingIndicatorState}`" @click="toggleStreaming">
          <div class="connection-indicator-fill"></div>
        </div>

      </div>
      <div class="card-body">

        <div>
          <pre>{{JSON.stringify(oscarPoolEventStreamSettings, null, 2)}}</pre>
        </div>

        <hr>

        <div class="ceremony-state-buttons">
          <input type="radio" class="btn-check" name="options-outlined" value="pre-ceremony" id="pre-ceremony" autocomplete="off" v-model="ceremonyStateRadioValue">
          <label class="btn btn-outline-mol" for="pre-ceremony">pre-ceremony</label>

          <input type="radio" class="btn-check" name="options-outlined" value="during-ceremony" id="during-ceremony" autocomplete="off" v-model="ceremonyStateRadioValue">
          <label class="btn btn-outline-mol" for="during-ceremony">during-ceremony</label>

          <input type="radio" class="btn-check" name="options-outlined" value="after-ceremony" id="after-ceremony" autocomplete="off" v-model="ceremonyStateRadioValue">
          <label class="btn btn-outline-mol" for="after-ceremony">after-ceremony</label>
        </div>

        <hr>

        <div class="form-group">
          <div class="message-preview" v-html="customMessageHtml"></div>
          <textarea class="form-control" rows="3" v-model="customMessage" />
          <button class="btn btn-sm btn-outline-mol" type="button" @click="updateCustomMessage">
            update custom message
          </button>
        </div>

      </div>
    </div>
    <hr>
    <h3>{{ceremonyHeaderText}}</h3>
    <div class="card bg-body-tertiary" v-for="(category) in categoryList" :key="category">
      <div class="card-header">
        <strong>{{category}}</strong>
      </div>
      <div class="card-body">
        <div v-for="(film) in filmsNominatedForCategory(category)" :key="film.name">
          <FilmLink :film_name="film.name" :film_id="film._id" :no_strikethrough="true"></FilmLink>
          <p v-for="nomination in film.nominationsForCategory(category)" :key="nominationKey(nomination)">
            <NominationWonCheckbox :nomination="nomination" @nomination-updated="getFilms"></NominationWonCheckbox>
            <small><i>{{nomination.nominee_display_text}}</i></small>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import axios from "axios";
import {Film} from "@/film";
import NominationWonCheckbox from "@/components/admin/NominationWonCheckbox.vue";
import {userStore} from "@/userStore";
import FilmLink from "@/components/FilmLink.vue";
import analytics from "@/analytics";

export default {
  name: "SetCategoryWinnersPage",
  components: {FilmLink, NominationWonCheckbox},
  props: ['ceremony_num'],
  data() {
    return {
      filmList: [],
      customMessage: '',
      streaming: false,
      oscarPoolEventStreamSettings: {},
      streamingIndicatorState: 'closed',
      ceremonyStateRadioValue: null,
    }
  },
  computed: {
    isAdmin() {
      return userStore.isAdmin();
    },
    ceremonyHeaderText() {
      return Film.getCeremonyHeaderText(this.ceremony_num);
    },
    categoryList() {
      return Film.getNominatedCategoriesForFilms(this.filmList).map(c => c.name);
    },
    customMessageHtml() {
      return this.customMessage.replaceAll(`<b>`, `<span style="font-weight: 600;">`).replaceAll(`</b>`, `</span>`);
    }
  },
  watch: {
    ceremonyStateRadioValue(/*newValue, oldValue*/) {
      this.updateCeremonyState();
    },
  },
  async created() {

    return this.getFilms()
        .then(() => {
          return axios.get(`/api/admin/oscar-pool-event-stream-settings`)
        })
        .then(response => {
          this.handleSettingsRespoinse(response);
        });
  },
  methods : {
    filmsNominatedForCategory(_category) {
      return Film.filterFilmsNominatedForCategory(this.filmList, _category, this.ceremony_num);
    },

    nominationKey(_nomination) {
      return `${_nomination._id}${_nomination.won ? 'w' : ''}`;
    },

    async getFilms() {

      return axios.get(`/api/ceremony/${this.ceremony_num}/films`)
          .then((response) => {
            this.filmList = response.data.map(f => new Film(f));
          })
          .catch((err) => {
            analytics.notifyBugsnagOfError(err);
          });
    },

    handleSettingsRespoinse(_response) {
      this.oscarPoolEventStreamSettings = _response.data;
      this.customMessage = this.oscarPoolEventStreamSettings.customMessage;
      this.streaming = this.oscarPoolEventStreamSettings.streaming;
      this.streamingIndicatorState = this.streaming? 'open' : 'closed';
      this.ceremonyStateRadioValue = this.oscarPoolEventStreamSettings.ceremonyState;
    },

    async updateStreamSettings(_data) {
      return axios.post(`/api/admin/oscar-pool-event-stream-settings`, _data)
          .then(response => {
            this.handleSettingsRespoinse(response);
            //console.log('oscarPoolEventStreamSettings', this.oscarPoolEventStreamSettings);
          });
    },

    async updateCustomMessage() {
      return this.updateStreamSettings({customMessage: this.customMessage});
    },

    async toggleStreaming() {
      this.streamingIndicatorState = 'connecting';
      return this.updateStreamSettings({streaming: !this.streaming});
    },

    async updateCeremonyState() {
      return this.updateStreamSettings({ceremonyState: this.ceremonyStateRadioValue});
    }
  }
}
</script>


<style scoped>
.card {
  border-color: crimson;
  margin-top: 20px;
  margin-bottom: 20px;
}

pre {
  /*width: fit-content;*/

  margin-left: auto;
  margin-right: auto;
  color: dimgrey;
}

.ceremony-state-buttons {
  text-align: center;
  padding-top: 20px;
  padding-bottom: 20px;

  .btn {
    margin-top: 0;
    margin-left: 10px;
    margin-right: 10px;
  }

}

.form-group {
  text-align: center;

  textarea {
    margin-top: 20px;
    margin-bottom: 20px;
  }
}

.stream-text {
  float: right;
  margin-right: 20px;
  color: DarkGray;
  font-size: smaller;
  font-style: italic;
}

.connection-indicator {
  position: absolute;
  top: 10px;
  right: 10px;

  position: absolute;

  display: inline-block;

  width: 20px;
  height: 20px;

  border-style: solid;
  border-radius: 50%;
  border-width: thin;
  border-color: var(--mol-color-gold);

  .connection-indicator-fill {
    background-color: white;
    height: 100%;
    width: 100%;
    border-radius: 50%;
  }

  &.open {
    border-color: limegreen;
    .connection-indicator-fill {
      background-color: limegreen;
      animation: pulseOpen 4s infinite;
    }
  }

  &.closed {
    border-color: lightgrey;
    .connection-indicator-fill {
      background-color: transparent;
    }
  }

  &.connecting {
    border-color: gold;
    .connection-indicator-fill {
      background-color: gold;
      animation: pulseConnecting 0.5s infinite;
    }
  }
}

@keyframes pulseConnecting {
  0% {opacity: 100%;}
  50% {opacity: 0%;}
  100% {opacity: 100%;}
}

@keyframes pulseOpen {
  0% {opacity: 100%;}
  50% {opacity: 10%;}
  100% {opacity: 100%;}

}

.message-preview {
  white-space: nowrap;
  overflow-x: auto;

  text-align: left;
  background-color: var(--bs-body-bg);
  color: var(--mol-color-gold-text);
  border-style: solid;
  border-width: thin;
  border-radius: 5px;
  border-color: lightgray;

  padding: 1em;
  margin-top: 2em;
  margin-bottom: 2em;
  font-size: smaller;
}

</style>